import { createContext } from 'react'

/** @type React.Context<firebase.app.App> */
const FirebaseContext = createContext()

export default FirebaseContext
